import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';

interface SimpleLayoutProps {
  children: ReactNode;
}

/**
 * 简单布局组件
 * 包含Header、内容区域和Footer
 */
const SimpleLayout = ({ children }: SimpleLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default SimpleLayout;
